import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const ACCESS_LEAD_TEMPLATE_SETTING = `${API_URL}lead-templates/`;

export const getLeadTemplateSetting = async (id: string, token: string) => {
  return axios.get(`${ACCESS_LEAD_TEMPLATE_SETTING}${id}/detail`, {
    headers: {
      'X-Auth-token': token
    }
  });
}